import { createUseStyles } from "react-jss";
import { useHistory } from "react-router-dom";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { theme } from "$utils/theme/bataillog";

import Text from "$components/Text";
import ConnexionLayout from "./ConnexionLayout";

function Succes() {
  const classes = useStyles();
  const { push } = useHistory();
  const onReview = () => {
    push("/connexion");
  };

  return (
    <ConnexionLayout
      containerClassName={classes.ConnexionLayout}
      onReview={onReview}
    >
      <div className={classes.check}>
        <CheckCircleIcon />
      </div>
      <Text type="h1" className={classes.title}>
        Confirmation
      </Text>
      <Text className={classes.subTitle}>
        Un e-mail avec les consignes vous a été envoyé. Veuillez vous connecter
        à votre messagerie et suivre les étapes indiquées
      </Text>
    </ConnexionLayout>
  );
}

const useStyles = createUseStyles(() => ({
  ConnexionLayout: {
    position: "relative",
  },
  check: {
    width: 78,
    height: 78,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: theme.color.greenLight,
    color: theme.color.green,
    borderRadius: "50%",
    "& .MuiSvgIcon-root": {
      width: 32,
      height: 32,
    },
  },
  title: {
    color: theme.color.green,
  },
  subTitle: {
    maxWidth: 416,
    textAlign: "center",
  },
}));
export default Succes;
